import { Input } from '../../../components/core/Input';
import { useForm } from 'react-hook-form';
import { useModal } from '../../../hooks/useModal';
import Select from '../../../components/others/Select/Select';
import { InputEmail } from '../../../components/others/InputEmail';
import { useEffect, useState } from 'react';
import { InputNumber } from '../../../components/others/InputNumber';
import LavorisService from '../../../services/LavorisService';
import { PrimaryButton } from '../../../components/others/ButtonPrimary';
import { useNavigate } from 'react-router-dom';
import { individualEntities } from '../../../services/publicData/PublicData.type';
import { FormPreValues } from './AddCompany.type';
import { ModalCheckEmail } from '../modalCheckEmail';
import { PhoneNumber } from '../../../components/others/PhoneNumber';
import SelectProvincias from '../../../components/others/SelectProvincias/SelectProvincias';
import { CircularProgress } from '@mui/material';
import Textarea from '../../../components/others/Textarea/Textarea';
import { useAlert } from '../../../hooks/useAlert';
import { getErrorMessage } from '../../../utils/ErrorHandlers';
import InputRadio from '../../../components/others/InputRadio/InputRadio';
import FileUpload from '../../../components/others/FileUploader/FileUploader';
import DynamicFileUpload from '../../../components/others/DynamicFileUpload';

const EMAIL_CHECKER = 'emailChecker';
interface selectedFiles {
  profileImages?: File[];
}
export default function AddCompany() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    watch,
    reset
  } = useForm<FormPreValues>({ mode: 'all' });
  const [isReady, setIsReady] = useState(false);
  const { openModal, isActive } = useModal();
  const { showAlert } = useAlert();
  const [isLoading, setIsLoading] = useState(false);
  const [registerError, setRegisterError] = useState(false);
  const [province, setProvince] = useState('');
  const LavorisInstance = LavorisService.getInstance();
  let navigate = useNavigate();
  const [selectedFiles, setSelectedFiles] = useState<selectedFiles | null>(
    null,
  );
  const [extraFiles, setExtraFiles] = useState<File[]>([]);
  const adminMail = watch('admin.email') || '';

  const onCancel = () => {
    navigate('/');
  };

  const [ivaConditionsValues, setivaConditionsValues] =
    useState<individualEntities>([
      {
        name: '',
        value: ''
      }
    ]);
  const [rubroCompanyValues, setrubroCompanyValues] =
    useState<individualEntities>([
      {
        name: '',
        value: ''
      }
    ]);

  const [fetchARTs, setARTs] = useState<individualEntities>([
    {
      name: '',
      value: ''
    }
  ]);

  const companyEmployeeRange = [
    {
      name: '1 a 50 empleados',
      value: '1-50',
    },
    {
      name: '51 a 200 empleados',
      value: '51-200',
    },
    {
      name: '201 a 500 empleados',
      value: '201-500'
    },
    {
      name: 'Más de 500 empleados',
      value: '500_PLUS'
    }
  ];

  const dataPublic = async () => {
    try {
      const publicData = await LavorisInstance.PublicData.getPublicData();
      if (publicData) {
        setrubroCompanyValues(publicData.rubroCompany);
        setivaConditionsValues(publicData.ivaConditions);
        setARTs(publicData.arts);
      }
    } catch (e: any) {
      console.log(e);
    }
  };

  const handleSelect = (selectedValue: any) => {
    setProvince(selectedValue);
  };

  useEffect(() => {
    const getData = async () => {
      await dataPublic();
      reset();
      setIsReady(true);
    };
    getData();
  }, []);

  const onSubmit = async (data: FormPreValues) => {
    setIsLoading(true);
    setRegisterError(false);
    const fullName = `${data?.admin?.lastName?.trim()}, ${data?.admin?.firstName?.trim()}`;
    const mergedFiles: File[] = [
      ...(selectedFiles?.profileImages ?? []),
      ...extraFiles,
    ];

    const mappedData = {
      admin: {
        email: data.admin.email,
        billingEmailEnabled: data.admin.billingEmailEnabled === 'Si' ? true : false,
        name: fullName.trim(),
      },
      company: {
        ...data.company,
        province: province,
        cuit: +data.company.cuit,
      }
    };
    if (!selectedFiles || !selectedFiles?.profileImages) {
      alert('Por favor, complete el campo de Constancia de AFIP');
      setIsLoading(false);
      return;
    }
    try {
      const companyCreated = await LavorisInstance.CompanyServices.addCompany(mappedData);
      if (companyCreated?.id) {
        const emailToSaved = {
          email: data.company.email,
          billingEmailEnabled: data.admin.billingEmailEnabled === 'Si' ? true : false
        }
        await uploadFile(companyCreated?.id, { profileImages: mergedFiles });

        await LavorisInstance.CompanyServices.updateCompanyEmails(companyCreated?.id, emailToSaved)
      }


      openModal(EMAIL_CHECKER);
    } catch (err: any) {
      console.log(err);
      showAlert(getErrorMessage({ title: 'Error al crear la compañia', err }));
      setRegisterError(true);
    } finally {
      setIsLoading(false);
    }
  };
  ///Funciones para la carga de archivos

  const updateUploadedFiles = (files: File[]) => {
    const updatedSelectedFiles: selectedFiles = { ...(selectedFiles ?? {}) };

    if (files.length > 0) {

      if (updatedSelectedFiles.profileImages) {
        updatedSelectedFiles.profileImages = [...updatedSelectedFiles.profileImages, ...files];
      } else {
        updatedSelectedFiles.profileImages = files;
      }
    }

    setSelectedFiles(updatedSelectedFiles);
  };

  // Para DynamicFileUpload: recibe la lista consolidada y la reemplaza (permite eliminar sin duplicar)
  const updateExtraFiles = (files: File[]) => {
    setExtraFiles(files);
  };

  const uploadFile = async (id: any, selectedFile: any) => {
    await LavorisInstance.CompanyServices.addFileRegister(
      { file: selectedFile },
      id,
    ).catch((e: any) => console.log(e));
  };
  if (!isReady) return <CircularProgress color="error" size={15} />;
  return (
    <>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="grid w-full gap-6 grid-flow rows"
      >
        <h6 className="subtitle">Datos de la empresa</h6>
        <Input
          type="text"
          label="Razón social *"
          fieldName="company.socialReason"
          register={register}
          required
          error={errors?.company?.socialReason}
        />
        <Input
          type="text"
          label="Nombre de fantasía *"
          fieldName="company.fantasyName"
          register={register}
          required
          error={errors?.company?.fantasyName}
        />
        <InputNumber
          label="CUIT - sin espacios ni guiones - *"
          nameInput="company.cuit"
          register={register}
          required
          error={errors}
        />
        <Select
          fieldName="company.ivaCondition"
          label="Condición frente al IVA *"
          options={ivaConditionsValues}
          register={register}
          required
          error={errors?.company?.ivaCondition}
          styles="rounded w-full h-[50px]"
        />
        <Select
          fieldName="company.heading"
          label="Rubro de la empresa *"
          options={rubroCompanyValues}
          register={register}
          required
          error={errors?.company?.heading}
          styles="rounded w-full h-[50px]"
        />
        <Select
          fieldName="company.ART"
          styles="w-full rounded-md h-12"
          register={register}
          label={'ART *'}
          required={true}
          error={errors?.company?.ART}
          options={fetchARTs}
        />
        <Select
          fieldName="company.employeeRange"
          styles="w-full rounded-md h-12"
          register={register}
          label={'Cantidad de empleados *'}
          required={true}
          error={errors?.company?.employeeRange}
          options={companyEmployeeRange}
        />
        <h6 className="subtitle">
          Información de contacto
        </h6>

        <SelectProvincias onSelect={handleSelect} defaultValue={province} />

        <Input
          type="text"
          label="Localidad o Barrio *"
          fieldName="company.location"
          register={register}
          required
          error={errors?.company?.residence}
        />
        <Input
          type="text"
          label="Dirección *"
          fieldName="company.residence"
          register={register}
          required
          error={errors?.company?.residence}
        />

        <Input
          type="text"
          label="Código postal *"
          fieldName="company.postalCode"
          register={register}
          required
          error={errors?.company?.postalCode}
        />

        <PhoneNumber
          label="Teléfono"
          fieldName="company.phoneNumber"
          control={control}
          error={errors?.company?.phoneNumber}
          required
        />
        <Input
          type="email"
          label="Email de la compañía (opcional)"
          fieldName="company.email"
          register={register}
          error={errors?.company?.email}
        />

        <Input
          type="text"
          label="Website (opcional)"
          fieldName="company.web"
          register={register}
        />
        <small className='className="w-full bg-[#F5F5F5] border-[md]'>*Subir archivos con el nombre "Constancia de (AFIP ó IIBB)" segun corresponda.</small>
        <FileUpload
          label="Cargar Constancia de AFIP"
          updateFilesCb={updateUploadedFiles}
          maxFileSizeInBytes={1000000}
          accept="image/jpeg,image/jpg,image/png,image/gif,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          multiple
        />

        <FileUpload
          label="Cargar Constancia de IIBB"
          updateFilesCb={updateUploadedFiles}
          maxFileSizeInBytes={1000000}
          accept="image/jpeg,image/jpg,image/png,image/gif,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          multiple
        />
        <DynamicFileUpload
          label="Otro archivo (opcional)"
          updateFilesCb={updateExtraFiles}
          maxFileSizeInBytes={1000000}
          accept="image/jpeg,image/jpg,image/png,image/gif,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          multiple
          buttonText="Agregar otro archivo"
        />

        <h6 className="subtitle">
          Datos del administrador
        </h6>

        <Input
          type="text"
          label="Apellido del administrador *"
          fieldName="admin.lastName"
          register={register}
          error={errors?.admin?.lastName}
          required={true}
        />
        <Input
          type="text"
          label="Nombre del administrador *"
          fieldName="admin.firstName"
          register={register}
          error={errors?.admin?.firstName}
          required={true}
        />

        <InputEmail
          label="E-mail del administrador *"
          nameInput="admin.email"
          register={register}
          required
          error={errors}
        />

        <small className='className="w-full bg-[#F5F5F5] border-[md]'>*Se enviará un mail a esta dirección para verificar la cuenta.</small>

        <InputRadio
          label="¿Habilitado para recibir emails de facturación? *"
          fieldName="admin.billingEmailEnabled"
          option1="Si"
          option2="No"
          register={register}
          defaultValue={'Si'}
          error={errors?.admin?.billingEmailEnabled}
          inputsContainerStyles="flex justify-around w-full"
          labelStyles='w-full'
        />

        <small className='w-full bg-[#F5F5F5] border-[md]'>** Una vez creada la cuenta, se podrá agregar más mails de facturación en el perfil de la compañía en Personas de Contactos</small>

        <Textarea
          register={register}
          fieldName="company.comments"
          label="Comentarios"
          error={errors?.company?.comments}
          rows={4}
          styles="rounded w-full"
        />
        <div className="w-100">
          {/* <Button
            type="button"
            text="Cancelar"
            className="font-bold text-[#DD6E6B] bg-[#FFFFFF] border-[#fb554f] rounded-md h-12 w-36 py-2 mr-2"
            onClick={onCancel}
          /> */}
          <PrimaryButton
            type="submit"
            text="Solicitar cuenta"
            styles="font-bold text-[#FFFFFF] border-[#fb554f] bg-[#fb544f] rounded-md  h-12 w-100 py-2"
            disabled={isLoading}
          />
        </div>

        <small>(*) Campos obligatorios</small>

        {registerError && (
          <small className="flex w-full mt-2 justify-center text-center text-red-500">
            {`No se pudo crear a la compañia, intente nuevamente más tarde
              Si sigue asi consulte con Lavoris.`}
          </small>
        )}
      </form>

      {isActive(EMAIL_CHECKER) && (
        <ModalCheckEmail urlTittle={EMAIL_CHECKER} mail={adminMail} show />
      )}
    </>
  );
}
